import { render, staticRenderFns } from "./AddChannelStage1.vue?vue&type=template&id=9a60857c&scoped=true"
import script from "./AddChannelStage1.vue?vue&type=script&lang=js"
export * from "./AddChannelStage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a60857c",
  null
  
)

export default component.exports